module.exports = __webpack_public_path__ + "images/emoji/star.b7c0fdb2bf70d8e9e708.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/star.png
// module id = TMdf
// module chunks = 14